export default {
  labels: {
    page: 'Página {{current}} de {{total}}',
    no_file_specified: 'No se especificó ningún archivo',
  },
  buttons: {
    previous: 'Anterior',
    next: 'Siguiente',
  },
};
